<template>
	<div class="wrap layout flex flex-center">
		<div class="box layout" style="background: transparent">
			<div class="left layout flex-center"  style="display: none">
				<div class="layout flex-center logo">
					<img style="width: 250px" src="../assets/img/opencloud-logo.png" alt="">
					</div>
			</div>
			<div class="right flex-center" style="display: none">

			</div>
			<slot></slot>
		</div>
	</div>

</template>

<script>
	export default {};
</script>

<style lang="scss" scoped>
	@import "@/assets/css/global.scss";
 .wrap {
    height: 100%;
    background-image: url("../assets/img/loginbg.png")!important;
    font-size: 14px;
    .box {
      width: 900px;
      height: 520px;
      justify-content: center;
      align-items: center;
      background: #fff;
      // padding: 20px;
      border-radius: 4px;
      .left {
        flex: 3;
        background: url("../assets/img/lgbg.png") no-repeat;
        background-size: 100% 100%;
        color: #fff;
        height: 100%;
        font-size: 25px;
        font-weight: 600;
      }
      .right {
        box-sizing: border-box;
        flex: 3;
        padding: 80px;
        .title {
          color: $content_color;
          font-size: 24px;
          margin-bottom: 30px;
          line-height: 33px;
        }
        .input {
          line-height: 50px;
          ::v-deep input {
            line-height: 50px;
            height: 50px;
            padding-left: 40px;
          }
          ::v-deep .el-input__prefix {
            font-size: 20px;
          }
        }
        .dis {
          justify-content: space-between;
        }
        .link {
          color: #1890ff;
          text-decoration: none;
        }
        .btn {
          width: 100%;
          height: 50px;
          font-size: 20px;
        }
        .last {
          justify-content: flex-end;
        }
      }
    }
  }
</style>
